<template>
    <div>
        <h1>KanBan</h1>
        <img src="../images/kanban.jpg" width="90%" alt="">
    </div>
</template>

<script>
export default {
    name: 'Home'
}
</script>

<style>
h1 {
    margin-top: 30px;
}

div {
    justify-items: center;
    text-align: center;
}
</style>